import EditableCell, { EditableCellProps } from "@components/EditableCell"
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"

export type Row = EditableCellProps & {
  label: string
}

type VerticalTableProps = {
  headers: string[]
  rows: Row[]
}

const VerticalTable = ({ headers, rows }: VerticalTableProps) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {headers.map((header, i) => (
              <TableCell key={i}>
                <strong>{header}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i}>
              <TableCell>{row.label}</TableCell>
              <EditableCell {...row} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default VerticalTable
